//封装高阶函数

interface BatchCallApiConfig<T extends any[]> {
  /** 等待一段时间缓存入参，再批量发起请求 */
  wait: number
  /**把多次请求的参数合并为一次请求的参数,lastDataList有可能为[] */
  handleData: (lastDataList: T | [], newDataList: T, config: BatchCallApiConfig<T>) => T
}

/**
 * 使api函数封装成“把多次调用合并成单次调用”的函数，可以用于防抖，以及把多个异步校验合并起来变成一个请求
 * @example 参考batchCallCheckBarcodeIsExist
 * @param fn
 * @param config
 * @returns
 */
export function batchCallApi<R, F extends (...a: any) => Promise<R>>(fn: F, config: BatchCallApiConfig<Parameters<F>>) {
  const cache = {
    data: [] as Parameters<F>,
    promise: null as Promise<R>,
    resolve: null,
    reject: null,
  }

  const manualCall = async () => {
    const r = await fn(...cache.data).then((res) => {
      cache.resolve(res)
      return res
    }, cache.reject)
    cache.data = [] as Parameters<F>
    cache.promise = null
    cache.resolve = null
    cache.reject = null
    return r
  }

  return (...data: Parameters<F>) => {
    // 缓存入参，延时调用
    cache.data = config.handleData(cache.data, data, config)
    if (!cache.promise) {
      cache.promise = new Promise((resolve, reject) => {
        cache.resolve = resolve
        cache.reject = reject
      })
      setTimeout(() => manualCall(), config?.wait)
    }
    return cache.promise
  }
}
